import { Injectable } from '@angular/core';
import {
  BaseService,
  HttpClient,
  HttpHeaders,
  HttpParams,
} from './base.service';
import { ISkuLocation } from '../shared/api';
import { AccountService } from './account.service';

@Injectable()
export class SkuLocationService extends BaseService<ISkuLocation> {
  constructor(accountService: AccountService, http: HttpClient) {
    super(accountService, http, 'skuLocation');
  }
}

export { ISkuLocation } from '../shared/api';
